import React from 'react'
import { useDispatch } from 'react-redux'

import { ActionIcon } from '../BottomHeader'
import { initiateBotCreationProcess } from '../../features/serverBots/actions/initiateBotCreationProcess'

export const CreateBotIcon: React.FC = () => {
  const dispatch = useDispatch()

  return (
    <ActionIcon
      iconName="plus"
      tooltipText="New bot"
      className="test-add-new-bot-button"
      onClick={() => dispatch(initiateBotCreationProcess())}
    />
  )
}
